import { Hyperlink } from '@strata/react-hyperlink';

interface UserGuideProps {
    title: string;
    navUrl: string;
    id: string;
}

export const UserGuide = ({ title, navUrl, id }: UserGuideProps) => (
    <div className="sds_knowledge-center__user-guide__item padding__around--medium">
        <div className="sds_knowledge-center__user-guide__item--title">{title}</div>
        <Hyperlink navUrl={navUrl} linkText="View Document" id={id} openInNewTab />
    </div>
);
